module.exports = __webpack_public_path__ + "img/product-clip-thumb.215dfdf4.png";